import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetUserReportsService = async (page = 1, limit = 10) => {
  return HTTP_CLIENT.get(
    `${Endpoint.reports.user.get}?page=${page}&limit=${limit}`
  );
};

const DeleteUserReportService = (id: number) => {
  return HTTP_CLIENT.delete(
    `${Endpoint.reports.user.delete.replace(":id", id.toString())}`
  );
};

export { GetUserReportsService, DeleteUserReportService };
